'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconPeople = function IconPeople(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ fill: 'none', height: '24', viewBox: '0 0 24 24', width: '24' }, custom),
    _react2.default.createElement(
      'g',
      { fill: color },
      _react2.default.createElement('path', { d: 'M8.70354553,5.3140873 C7.64803532,5.3140873 6.79007614,6.35535714 6.79007614,7.6406746 C6.79007614,8.91785714 7.64803532,9.95912698 8.70354553,9.95912698 C9.75742308,9.95912698 10.6153823,8.91785714 10.6153823,7.6406746 C10.6153823,6.35535714 9.75742308,5.3140873 8.70354553,5.3140873 Z M8.70354553,11.5861111 C6.74762716,11.5861111 5.15742308,9.81269841 5.15742308,7.6406746 C5.15742308,5.46051587 6.74762716,3.68710317 8.70354553,3.68710317 C10.6586476,3.68710317 12.2480353,5.46051587 12.2480353,7.6406746 C12.2480353,9.81269841 10.6586476,11.5861111 8.70354553,11.5861111 L8.70354553,11.5861111 Z' }),
      ' ',
      _react2.default.createElement('path', { d: 'M4.14354553,18.8831349 L13.1280353,18.8831349 L13.3068108,16.2636905 C13.3435455,15.7430556 12.8537496,14.9132937 12.1925251,14.669246 C9.91415777,13.855754 7.36477002,13.855754 5.07334144,14.669246 C4.41783124,14.9132937 3.92885165,15.7430556 3.96395369,16.2636905 L4.14354553,18.8831349 Z M13.8904843,20.510119 L3.38028022,20.510119 C2.95089246,20.510119 2.59579042,20.1765873 2.56558634,19.7535714 L2.33374961,16.3694444 C2.24640267,15.0678571 3.22354553,13.6198413 4.5149741,13.139881 C7.17946389,12.1962302 10.1035455,12.1962302 12.7484435,13.139881 C14.049668,13.6198413 15.0268108,15.0678571 14.9361986,16.3775794 L14.7051782,19.7535714 C14.6766067,20.1765873 14.3190557,20.510119 13.8904843,20.510119 L13.8904843,20.510119 Z' }),
      ' ',
      _react2.default.createElement('path', { d: 'M20.2488516,20.510119 L16.0635455,20.510119 C15.612117,20.510119 15.247219,20.1440476 15.247219,19.696627 C15.247219,19.2492063 15.612117,18.8831349 16.0635455,18.8831349 L19.4864027,18.8831349 L19.6349741,16.727381 C19.6635455,16.3125 19.2586476,15.6454365 18.7435455,15.4583333 C17.8300761,15.1329365 16.8651782,14.9621032 15.8815047,14.9458333 C15.4317088,14.9376984 15.0717088,14.5634921 15.0798721,14.1160714 C15.0880353,13.6686508 15.4578312,13.2944444 15.9100761,13.3188492 C17.0708925,13.335119 18.2129333,13.5384921 19.3019129,13.9289683 C20.4684435,14.360119 21.3459945,15.6617063 21.2643619,16.8331349 L21.0635455,19.7535714 C21.0333414,20.1765873 20.6774231,20.510119 20.2488516,20.510119' }),
      ' ',
      _react2.default.createElement('path', { d: 'M17.0276272,7.5593254 C16.3043619,7.5593254 15.7157904,8.29146825 15.7157904,9.18630952 C15.7157904,10.0892857 16.3043619,10.8214286 17.0276272,10.8214286 C17.7500761,10.8214286 18.3386476,10.0892857 18.3386476,9.18630952 C18.3386476,8.29146825 17.7500761,7.5593254 17.0276272,7.5593254 Z M17.0276272,12.4484127 C15.40477,12.4484127 14.0831374,10.984127 14.0831374,9.18630952 C14.0831374,7.39662698 15.40477,5.93234127 17.0276272,5.93234127 C18.6513006,5.93234127 19.9713006,7.39662698 19.9713006,9.18630952 C19.9713006,10.984127 18.6513006,12.4484127 17.0276272,12.4484127 L17.0276272,12.4484127 Z' }),
      ' '
    )
  );
};

IconPeople.propTypes = {
  color: _propTypes2.default.string
};

IconPeople.defaultProps = {
  color: _colors2.default.icons
};

IconPeople.displayName = 'IconPeople';

exports.default = IconPeople;
module.exports = exports.default;